import { Respuesta } from './../entities/respuesta.entity';
import { UsuarioUpdate } from './../entities/usuarioUpdate.entity';
import { UsuarioOnline } from './../entities/UsuarioOnline.entity';
import { Component, OnInit } from '@angular/core';
import { SessionService } from '../services/session.service';
import { UserService } from '../services/user.service';
import { Router } from '@angular/router';
import { validate, ValidationError } from 'class-validator';
import { UsuarioValidate } from '../entities/usuarioValidate.entity';
import { AlertBoxComponent } from '../shared/alertbox.component';

@Component({
  selector: 'app-usuario',
  templateUrl: './usuario.component.html'
})
export class UsuarioComponent implements OnInit {
  public nombre: string;
  public login: string;
  public email: string;
  public telefono1: string;
  public telefono2: string;
  public oldPassword: string;
  public password: string;
  public passwordConfirm: string;
  public efactura: boolean;
  public avisoEmail: string;
  public inputErrorNombre = false;
  public inputErrorEmail = false;
  public inputErrorTelefono1 = false;
  public inputErrorTelefono2 = false;
  public inputErrorPass: boolean;
  public inputErrorOldPass: boolean;
  public user: UsuarioUpdate;
  public messageCabecera: string;
  public messageComplet: string;
  public typeException: number;

  constructor(private userService: UserService, private sessionService: SessionService, private router: Router) { }

  ngOnInit() {
    if (this.sessionService.isAuthenicated === true) {
      this.nombre = this.sessionService.nombre;
      this.login = this.sessionService.login;
      this.email = this.sessionService.email;
      this.telefono1 = this.sessionService.telefono;
      this.telefono2 = this.sessionService.telefono2;
      this.efactura = this.sessionService.efactura;
      this.avisoEmail = 'Atención!!! La respuesta a su solicitud puede recibirla en la carpeta de correo no deseado. '
        + 'En el caso de cuentas de correo de Hotmail, vemos necesario añadir previamente a sus contactos la cuenta '
        + this.sessionService.datosExplotacion.Email + ' para asegurarse de que recibirá nuestros correos.';
    } else {
      this.router.navigate(['/public/login']);
    }
  }

  public clearInputErrors() {
    this.inputErrorNombre = false;
    this.inputErrorEmail = false;
    this.inputErrorTelefono1 = false;
    this.inputErrorTelefono2 = false;
    this.inputErrorPass = false;
    this.inputErrorOldPass = false;
    this.messageCabecera = '';
    this.messageComplet = '';
    this.typeException = -1;
  }

  public showErrors(resultado: ValidationError[]) {
    for (const item of resultado) {
      switch (item.property) {
        case 'Nombre':
          this.inputErrorNombre = true;
          break;
        case 'EMail':
          this.inputErrorEmail = true;
          break;
        case 'Telefono1':
          this.inputErrorTelefono1 = true;
          break;
        case 'Telefono2':
          this.inputErrorTelefono2 = true;
          break;
      }
    }
  }

  public actualizarUsuario() {
    this.clearInputErrors();
    let usuarioOnline = new UsuarioOnline;
    usuarioOnline = this.sessionService.usuario;
    usuarioOnline.Nombre = this.nombre;
    usuarioOnline.EMail = this.email;
    usuarioOnline.Telefono1 = this.telefono1;
    usuarioOnline.Telefono2 = this.telefono2;
    usuarioOnline.EFactura = this.efactura;
    usuarioOnline.Password = this.password;

    this.password = this.password === undefined ? '' : this.password;
    this.passwordConfirm = this.passwordConfirm === undefined ? '' : this.passwordConfirm;
    this.oldPassword = this.oldPassword === undefined ? '' : this.oldPassword;

    this.user = new UsuarioUpdate;
    this.user.UsuarioOnline = usuarioOnline;
    this.user.cambioPassword = false;
    this.user.oldPassword = this.oldPassword;

    this.inputErrorPass = false;
    this.inputErrorOldPass = false;

    if (this.password !== '' || this.passwordConfirm !== '') {
      if (this.password === this.passwordConfirm) {
        this.user.cambioPassword = true;
        this.user.passwordRepetir = this.passwordConfirm;
      } else {
        this.inputErrorPass = true;
      }

      if (this.oldPassword === '') {
        this.inputErrorOldPass = true;
      }
    } else if (this.oldPassword !== '') {
      this.inputErrorPass = true;
    }

    if (document.getElementById('top') !== null)
      document.getElementById('top').scrollIntoView();

    if (this.updateUser()) {
      validate(this.cargarDatosValidate(usuarioOnline)).then(resultado => {
        if (resultado.length > 0) {
          this.showErrors(resultado);
        } else {
          this.doUpdateUser(usuarioOnline);
        }
      });
    } else if (this.password !== '' && this.passwordConfirm !== '' && this.oldPassword !== '' &&
      !this.inputErrorPass && !this.inputErrorOldPass) {
      this.doUpdateUser(usuarioOnline);
    }
  }

  private doUpdateUser(usuarioOnline: UsuarioOnline) {
    this.userService.updateuser(this.sessionService.explotacion, this.user)
      .then(
        response => this.updateuserOnSuccess(usuarioOnline),
        response => this.updateuserOnError(response)
      );
  }

  public updateuserOnSuccess(usuarioOnline: UsuarioOnline) {
    this.messageCabecera = 'Datos actualizados correctamente';
    this.messageComplet = 'Sus datos han sido actualizados correctamente';
    this.typeException = 2;
    AlertBoxComponent.changeMensaje.next(this.typeException);
    this.sessionService.efactura = this.efactura;
    this.sessionService.usuario = usuarioOnline;
    this.sessionService.nombre = this.nombre;
    this.sessionService.email = this.email;
    this.sessionService.telefono = this.telefono1;
    this.sessionService.telefono2 = this.telefono2;
    this.cleanPassInputs();
  }

  public updateuserOnError(response: any) {
    this.messageCabecera = 'Datos no actualizados';
    if (response.Ex) {
      this.messageComplet = response.Ex.Message;
    }
    if (response.TipoExcepcion >= 0) {
      this.typeException = response.TipoExcepcion;
    }
    AlertBoxComponent.changeMensaje.next(this.typeException);
  }

  public cargarDatosValidate(usuario: UsuarioOnline): UsuarioValidate {
    const usuarioValidate = new UsuarioValidate();
    usuarioValidate.EMail = usuario.EMail;
    usuarioValidate.Nombre = usuario.Nombre;
    usuarioValidate.Telefono1 = usuario.Telefono1;
    usuarioValidate.Telefono2 = usuario.Telefono2;
    return usuarioValidate;
  }

  public updateUser(): boolean {
    if (this.nombre !== this.sessionService.nombre
      || this.email !== this.sessionService.email
      || this.telefono1 !== this.sessionService.telefono
      || this.telefono2 !== this.sessionService.telefono2
      || this.efactura !== this.sessionService.efactura) {
      return true;
    } else {
      return false;
    }
  }

  public cleanPassInputs() {
    this.oldPassword = '';
    this.password = '';
    this.passwordConfirm = '';
  }

}
